import Image from "next/image";

import { RichText } from "@sitecore-jss/sitecore-jss-nextjs";

import { Button } from "components/Feature/Custom/Button";

import { extractRelativePath } from "components/Shared/DomainSplit";

import { TemplateDownloadIcon } from "./TemplateDownloadIcon";
import { useTrackedHrefDownload } from "src/hooks/useTrackedHrefDownload";

type TitleDescriptionBtnsProps = {
  SectionId: string; 
  fields :TitleDescriptionBtnsFields;
  locale:string;
}

function TitleDescriptionBtns (props: TitleDescriptionBtnsProps) {
    const cta = useTrackedHrefDownload(props.locale, "mocHome");

    const firstButtonWithLinkValue = props?.fields?.Buttons?.find(button => button?.fields?.BtnUrl?.value?.href);

    return (
        <>  
            {
                (
                    props?.fields?.Title?.value ||
                    props?.fields?.Description?.value ||
                    (props?.fields?.Buttons.length > 0)
                ) && (
                    <section 
                        id={props?.SectionId}
                        className={
                            (
                                !props?.fields?.isLightBgColor?.value &&
                                !props?.fields?.isDarkBgColor?.value
                            ) ? "bg-transparent" : (
                                props?.fields?.isLightBgColor?.value ? "bg-neutral-100" : props?.fields?.isDarkBgColor?.value ?"bg-neutral-300" : ''
                            )
                        }
                    >
                        <div 
                            className="responsive flex flex-col items-start gap-6 md:gap-8 w-full py-10"
                        >
                            {
                                props?.fields?.Title?.value && (
                                    <h1 
                                        id={'title-' + props?.SectionId}
                                        className="animate-top-dga text-neutral-800 text-2xl md:text-3xl font-bold"
                                    >
                                        {props?.fields?.Title?.value}
                                    </h1>
                                )
                            }

                            {
                                props?.fields?.Description?.value && (
                                    <RichText 
                                        id={'desc-' + props?.SectionId} 
                                        field={props?.fields?.Description}
                                        className="animate-top-dga overflow-hidden text-neutral-800 text-start text-base md:text-lg font-normal"
                                    />
                                )
                            }

                            {
                                (props?.fields?.Buttons.length > 0) && (
                                    <div className="overflow-hidden animate-top-dga flex flex-wrap gap-2 md:gap-4 w-full items-center justify-start">
                                        {props?.fields?.Buttons?.map((btn: any, index: number) => {
                                            return (
                                                    cta.linkButtonIsTrackedDownload(btn) ? (
                                                        btn?.fields?.BtnText?.value && 
                                                            <button
                                                                type="button"
                                                                key={btn?.id || index}
                                                                onClick={() => void cta.handleLinkButton(btn)}
                                                                className={`inline-flex items-center gap-2 ${btn?.id === firstButtonWithLinkValue?.id ? "dga-primary-button" : "dga-secondary-button"}`}
                                                            >
                                                                {btn?.fields?.BtnText?.value}
                                                                <TemplateDownloadIcon
                                                                    variant={btn?.id === firstButtonWithLinkValue?.id ? "white" : "grey"}
                                                                    size={20}
                                                                />
                                                            </button>
                                                    ) : (
                                                        btn?.fields?.BtnText?.value && (
                                                            <Button
                                                                key={btn?.id || index}
                                                                text={btn?.fields?.BtnText?.value}
                                                                redirect={btn?.fields?.BtnUrl?.value?.href}
                                                                target={btn?.fields?.BtnUrl?.value?.target}
                                                                linktype={btn?.fields?.BtnUrl?.value?.linktype}
                                                                classNames={`${btn?.id === firstButtonWithLinkValue?.id ? "dga-primary-button" : "dga-secondary-button"} !border-none !text-base !font-medium !py-2 !px-4`}
                                                            />
                                                        )
                                                    )
                                                )
                                            }
                                            )
                                        }
                                    </div>
                                )
                            }
                        </div>
                    </section>
                )
            }

            {
                props?.fields?.Pattern?.value?.src && (
                        <div 
                            id={props?.SectionId + '-pattern'} 
                            className='relative w-full max-h-[200px] overflow-hidden'  
                            style={{ 
                                height: +props?.fields?.Pattern?.value?.height + 'px' 
                            }}
                        >
                            <Image 
                                src={extractRelativePath(props?.fields?.Pattern?.value?.src)}  
                                alt={props?.fields?.Pattern?.value?.alt || props?.fields?.Title?.value || "Event pattern background"}
                                layout='fill' 
                                objectFit='cover' 
                                className='animate-top-dga' 
                            />
                        </div>
                    )
            }
        </>
    )
}

export default TitleDescriptionBtns

export type TitleDescriptionBtnsCo = {
    displayName: "TitleDescriptionBtns",
    fields: TitleDescriptionBtnsFields
}

export type TitleDescriptionBtnsFields = {
    isScrollAllowed: {
        value: string;
    },
    Title: {
        value: string;
    },
    Description: {
        value:  string;
    },
    isLightBgColor: {
        value: string;
    }
    isDarkBgColor: {
        value: string;
    },
    Buttons: 
        {
            fields: {
                  BtnText: {
                      value:  string;
                  },
                  BtnUrl: {
                      value: {
                        href: string;
                        linktype: string;
                        url: string;
                        anchor: string;
                        target: string;
                    }
                  },
                  File: {
                      value: {
                          src:  string;
                          name:  string;
                          title:  string;
                          extension:  string;
                          mimeType:  string;
                          size:  string;
                      }
                  },
                  isFile: {
                      value: boolean;
                  }
              }
              id: string;
            }[],
    ScrollToText: {
        value:  string;
    },
    Pattern: {
        value: {
            src:  string;
            alt:  string;
            width: string;
            height:  string;
        }
    },
    SectionTemplate: {
        displayName:  string;
        fields: {
            Title: {
                value:  string;
            }
        }
    }
}